// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2-MRi","topBottomGutter":"Layout_topBottomGutter__1s1Vm"};